<template>
  <el-dialog
    ref="modal"
    class="success-promo-modal"
    :visible="show"
    @update:visible="$emit('update:show', false)"
  >
    <div class="success-promo">
      <h1>🎉 Hooray 🎉</h1>
      <h2>Your signature successfully created and copied!</h2>
      <br>
      <p>Follow the <a href="https://fusebill.3ph.com/delivery/signature/installing_signature.htm" target="_blank">instructions to install it in Outlook 365</a></p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SuccessPromo',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  created () {
    this.$root.$on('social_shares_open', (payload) => {
      this.gaEventClick(`social ${payload}`)
    })
  }
}
</script>

<style lang="scss">
.social-icon {
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  width: 38px;
  border-radius: 5px;
  border: 1px solid #ddd;
  cursor: pointer;
  margin: 0 5px;
  svg {
    transition: all .2s;
  }
  &--fb {
    &:hover {
      svg {
          fill: lighten(#3b5998, 15%);
        }
      }
    svg {
      fill: #3b5998;
    }
  }
  &--vk {
     &:hover {
      svg {
          fill: lighten(#45668e, 15%);
        }
      }
    svg {
      fill: #45668e;
    }
  }
  &--tw {
    &:hover {
      svg {
          fill: darken(#1da1f2, 10%);
        }
      }
    svg {
      fill: #1da1f2;
    }
  }
  &--reddit {
    &:hover {
      svg {
          fill: darken(#ff4500, 10%);
        }
      }
    svg {
      fill: #ff4500;
    }
  }
  &--telegram {
    &:hover {
      svg {
          fill: lighten(#0088cc, 10%);
        }
      }
    svg {
      fill: #0088cc;
    }
  }
}
.success-promo {
  text-align: center;
}
.success-promo-modal {
  .el-dialog {
    &__header {
      padding-bottom: 0;
    }
    h1 {
      margin-top: 0;
    }
  }
}
</style>
